import { Grid, makeStyles, useTheme } from '@mui/material';
import styles from './guidance-score.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfDoubleArrowIcon,
  CcfTypography,
  SemiCircle,
} from '@nice-ccf/ui-controls';
import {
  ccfrtigActions,
  selectIsGuidanceScoreExpanded,
  selectIsSuggestionSummaryExpanded,
} from '../+state/ccf-rtig.slice';
import CcfRtigAccordionStyles from '../ccf-rtig-accordion.styles';

/* eslint-disable-next-line */
export interface GuidanceScoreProps {
  guidanceScoreList: any;
}

/**
 * Component For guidance score to be updated on interval
 * @param param0 - GuidanceScoreProps
 * @example - <GuidanceScore />
 * @returns
 */
export function GuidanceScore(props?: any) {
  const dispatch = useDispatch();
  const isSuggestionSummaryExpanded = useSelector(
    selectIsSuggestionSummaryExpanded
  );
  const isGuidanceScoreExpanded = useSelector(selectIsGuidanceScoreExpanded);
  const { setSuggestionSummaryExapnded, setGuidanceScoreExapnded } =
    ccfrtigActions;
  const theme = useTheme();
  const simStyles = CcfRtigAccordionStyles(theme);

  /**
   * Component to provide protected routes for application
   * @param param0 - CcfProtectedRouteProps
   * @example - <CcfProtectedRoute />
   * @returns
   */
  const renderGuidanceScores = () => {
    return (
      <div className={`row  ${styles['guidance-score']}`}>
        <Grid container spacing={1}>
          {props.guidanceScoreList
            .filter((metric: any) => metric.isValid)
            .map((metric: any, i: any) => (
              <Grid
                item
                xs={3}
                sm={4}
                key={i}
                className="guidance-score-item"
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="space-between"
              >
                <SemiCircle
                  percentage={metric.percentage}
                  imageSrc={metric.image_src}
                  label={metric.frienly_name}
                  showLabel={true}
                />
              </Grid>
            ))}
        </Grid>
      </div>
    );
  };

  /**
   * Function for accordion click
   * @param param -
   * @example - onAccodianClick()
   * @returns
   */
  const onAccodianClick = () => {
    //dispatch(setSuggestionSummaryExapnded(!isSuggestionSummaryExpanded));
    dispatch(setGuidanceScoreExapnded(!isGuidanceScoreExpanded));
  };

  return (
    <div className={styles['guidance-score']}>
      <CcfAccordion
        sx={simStyles.accordionContainer}
        expanded={isGuidanceScoreExpanded}
        onChange={onAccodianClick}
      >
        <CcfAccordionSummary
          expandIcon={<CcfDoubleArrowIcon sx={simStyles.expandedIcon} />}
          aria-controls="suggestionSummary-content"
          id="suggestionSummary-header"
          sx={simStyles.accordionHeader}
        >
          <CcfTypography className="txt-guidance-score">
            Your Guidance Score
          </CcfTypography>
        </CcfAccordionSummary>

        <CcfAccordionDetails>{renderGuidanceScores()}</CcfAccordionDetails>
      </CcfAccordion>
    </div>
  );
}

export default GuidanceScore;
